import React from 'react';
import user from '../Auth/user';
import firebase from '../firebase';
import compose from '../compose';
import { translate } from 'react-i18next';
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';
import Snackbar from 'material-ui/Snackbar';

class AddStockDialog extends React.Component {
  constructor(props) {
    super(props);
    this.initialState =  {
      product: '',
      addAmount: '1',
      savedSnackbar: false
    };

    this.state = {
      ...this.initialState
    };
  }

  closeSnackbar = () => {this.setState({savedSnackbar: false});}

  handlePriceChange = (event, price) => this.setState({price: price.trim().replace(',','.'), priceError: ''})

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.product) {
      this.setState({product: nextProps.product, totalCount: nextProps.product.totalCount});
    }
  }
  handleSave = () => {
    if (!this.state.addAmount) return;

    const {firebase, user} = this.props;
    const today = new Date().getTime();

    const product = this.state.product;
    product.addedCount = this.state.addAmount;
    product.countAfter = (+(product.totalCount || 0) + +(product.addedCount || 0));

    firebase.database().ref(`shopkeepers/${user.shopkeeperId}/stands/${this.props.standKey}/products/${this.state.product.key}`)
      .update({totalCount: product.countAfter});
    firebase.database().ref(`shopkeepers/${user.shopkeeperId}/inventoryChanges`)
      .push({date: today, delta: product.addedCount, standId: this.props.standKey, productId: this.state.product.key})
      .then(() => {
        this.setState({ ...this.initialState, savedSnackbar: true});
        this.props.handleClose(product.countAfter);
      });
  }
  handleClose = () => {
    this.setState({ ...this.initialState});
    this.props.handleClose();
  }

  handleAmount = (event) => {
    const isInteger = event.target.value >>> 0 === parseFloat(event.target.value);
    const isEmpty = event.target.value === '';
    if (isInteger || isEmpty) {
      this.setState({addAmount: event.target.value});
    }
  }

  render()  {
    const {t} = this.props;
    const actions = [
      <FlatButton
        label={t('cancel')}
        onTouchTap={this.handleClose}
      />,
      <RaisedButton
        label={t('save')}
        primary={true}
        onTouchTap={this.handleSave}
      />,
    ];

    const contentStyle = (this.props.eventPosition)
      ? {
        position: 'absolute',
        maxWidth: '310px',
        top: this.props.eventPosition.y,
        left: this.props.eventPosition.x
      }
      : {
        maxWidth: '300px'
      };

    const title = (this.props.standName)
      ? t('product.addStock') + ' - ' + this.props.standName
      : t('product.addStock') + ' - ' + this.state.product.name;

    const snackbar = (this.props.standName)
      ? t('stand.stockAdded') + ' - ' + this.props.standName
      : t('stand.stockAdded') + ' - ' + this.state.product.name;

    return (
      <div>
        <Dialog title={title}
          titleStyle={{maxHeight: '40px', overflow: 'hidden'}}
          open={this.props.open}
          onRequestClose={this.handleClose}
          actions={actions}
          contentStyle={contentStyle}>
          <TextField
            type='number'
            min='1'
            max='99999'
            style={{width: 150}}
            inputStyle={{textAlign: 'right'}}
            defaultValue='1'
            hintText={t('stock')}
            floatingLabelText={t('stock')}
            onChange={this.handleAmount}
          />
        </Dialog>
        <Snackbar
          open={this.state.savedSnackbar}
          message={snackbar}
          autoHideDuration={4000}
          onRequestClose={this.closeSnackbar}
        />
      </div>
    );
  }
}

const enhance = compose(translate(), firebase, user);

export default enhance(AddStockDialog);



// WEBPACK FOOTER //
// ./src/Stand/AddStockDialog.js